<template>
    <div>
      <div class="mark mb-3">标记信息</div>
      <ul class="mark-list">
        <li>订单号{{flagtiem.oid}}</li>
        <li>团&emsp;号：{{flagtiem.hotel_title}}（{{flagtiem.num}}人）</li>
        <li>类&emsp;型：{{flagtiem.order_type==1?'住宿订单':'纯会议订单'}}丨{{flagtiem.team_type==1?'旅游团':'会议团'}}</li>
      </ul>
      <div class="sign">
        <div class="sign-nr">
          <span>标记颜色:</span>
          <el-radio-group v-model="Flagdata.flag" class="start">
            <el-radio 
              :label="item.id" :key="item.id" class="ml-0 mr-2"
              :disabled='flagtype!=storeInfo.type'
              v-for="item in breakfastArr">
              <i class="el-icon-s-flag" :class="item.name"></i>  
            </el-radio>
          </el-radio-group>
        </div>
        <div class="sign-nr">
          <span>标记信息:</span>
          <el-alert
            class="alert"
            title="标记信息仅自己可见"
            :closable="false"
            type="warning"
            show-icon>
          </el-alert>
        </div>
        <div class="sign-nr">
          <span>备注信息:</span>
          <div class="control">
            <textarea class="form-control"  :disabled='flagtype!=storeInfo.type' v-model="Flagdata.flag_content" placeholder="标记信息作为你对这笔订单的标记记录，仅自己可见。"></textarea>
            <el-button class="button" size="small" type="primary" @click="ButtonSubmit" v-if="flagtype==storeInfo.type">确定信息</el-button>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import { mapGetters, mapState,mapActions } from 'vuex'
export default {
  name: 'HotelOrderIFlag',
  props: {
    flagtiem: {},
    flagtype:'',
  },
  data() {
    return {
      breakfast:0,
      breakfastArr:[
        {name:'delete',id:0},
        {name:'red',id:1},
        {name:'Orange',id:2},
        {name:'green',id:3},
        {name:'greys',id:4},
        {name:'purple',id:5}
      ],
      Flagdata:{
        oid:'',
        flag:0,
        flag_content:'',
      },
    }
  },
  created() {
    // this.flagtiem.room_need=JSON.parse(this.flagtiem.room_need);
    this.Flagdata.flag=this.orderStatusArr()*1;
    this.Flagdata.flag_content=this.orderStatusArr(1);
      console.log(this.flagtiem);
  },
  computed: {
    ...mapState(['currentStoreInfo']),
    ...mapGetters(['storeInfo','userInfo','isGroup','isAdmin']),
  },
  watch: {
    flagtype(newVal) {
        this.Flagdata.flag=this.orderStatusArr();
        this.Flagdata.flag_content=this.orderStatusArr(1);
    }
  },
  methods: {
    ...mapActions(['OrderHotelFlag','searchOrder']),
    orderStatusArr(n) {
      let flagtiem=this.flagtiem;
      if(n==1){
      switch (this.flagtype*1) {
        case 99: return flagtiem.admin_flag_content;
        case 2:  return flagtiem.travel_flag_content;
        case 3:  return flagtiem.hotel_flag_content;
      }
      }else{
        switch (this.flagtype*1) {
          case 99: return flagtiem.admin_flag*1;
          case 2:  return flagtiem.travel_flag*1;
          case 3:  return flagtiem.hotel_flag*1;
        } 
      }
    },
    ButtonSubmit(){
      let Flagdata=this.Flagdata;
      let res = (() => {
          // if (Flagdata.flag==0)  return { code: false, msg: '请选择标记' }
          // if (Flagdata.flag_content=="") return { code: false, msg: '请填写标记信息' }
          return { code: true, msg: '验证通过' }
      })();
      Flagdata.oid=this.flagtiem.oid;
      if (res.code) {
         this.OrderHotelFlag({
         oid:Flagdata,
         successFun: () => {
                  this.$emit('getOrderList',true);
                  this.$emit('firmPanel');
                  this._alert('提交成功');
              }
          });
      } else this._alert(res.msg, null, 'error')
    }
  },
}
</script>

<style scoped>
  .mark{
    text-align: center;
    font-size: 16px;
    font-weight: bold;
  }
  .dingx{
    font-size: 17px;
  }
  .cardItem{
    color: #333;
  }
  .ren{
    font-weight: bold;
  }
  .start{
    float: left;
    margin-top: 3px;
  }
  .sign{
    width: 100%;
    margin-top: 40px;
  }
  .sign span{
    width: 80px;
    text-align: right;
    float: left;
    margin-right: 8px;
  }
  .sign-nr{
    overflow: hidden;
    margin-bottom: 12px;
    display: flex;
  }
  .alert{
    float: right;
    width: 85%;
  }
  .flag{
    color: #fe8800;
  }
  .lsit-sytile{
    border: 1px #94c9fb solid;
    background-color: #fff;
    margin-top: 20px;
  }
  .rl{
    float: right;
  }
  .rl i{
    font-size: 16px;
    margin-left: 10px;
    cursor: pointer;
  }
  .list-item{
    width: 100%;
    text-align: left;
  }
  .list-item>li{
    padding: 20px 0;
  }
  .top-l{
    border-bottom: 1px #94c9fb solid;
    padding: 10px 20px;
    line-height: 24px;
    overflow: hidden;
  }
  .top-l .ft{
    float: left;
    line-height: 18px;
  }
  .top-l .ft p{
    float: left;
    margin-right: 30px;
  }
  .title span{
      margin-right: 8px;
      color: #333;
  }
  .type{
    text-align: center;
    border-right:1px #eee solid;
    border-left: 1px #eee solid;
    color: #333;
  }
  .type p:nth-child(1){
    margin-top: 0;
  }
  .type p{
    margin-top: 12px;
  }
  .date_in .time{
    margin-left: 12px;
    width: 38%;
    text-align: center;
    color: #333;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .date_in .time i{
    font-weight: bold;
    font-style: normal;
    color: #555;
  }
  .date_in .time p{
    margin-top: 12px;
  }
  .date_in .time p:nth-child(1){
    margin-top: 0px;
  }
  .date_in .time p span{
    color: var(--smtc-color-primary); 
  }
  .center{
    text-align: center;
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .title{
    margin-left: 20px;
    cursor:initial;
  }
  .delete{
    color: #999999;
  }
  .red{
    color: #dc3545;
  }
  .Orange{
    color: #ffa800;
  }
  .green{
    color: #09af09;
  }
  .grey{
    color: #1760fb;
  }
  .purple{
    color: #c811df;
  }
  .control{
    float: right;
  }
  .form-control{
    width: 440px;
    height: 100px;
    padding: 10px;
    border: 1px #eee solid;
    resize: none;
  }
  .button{
    margin: 0 auto;
    display: block;
    margin-top: 20px;
  }
  
  .needarr{
    float: left;
    display:flex;
    justify-content: center;
    flex-direction: column;
    min-height: 60px;
    margin-left: 20px;
    color: #333;
  }
  .needarr span{
    display: block;
    float: left;
    width: 50px;
    margin-top: 2px;
  }
    .lisd{
    display: flex;
    justify-content:center;
    color: #333;

  }
  .lisds{
    font-weight: bold;
    color: #333;
  }
    .hotels{
    margin-top: 12px;
    display: flex;
    justify-content: left;
  }
  .hotels p{
    display: flex;
    justify-content: center;
    height: 64px;
    flex-direction: column;
    margin-left: 16px;
     color: #333;
  }
  textarea:focus {
      outline: none;
  }
  .cup{
    cursor: pointer;
  }
  .title-w{
    display: flex;
    justify-content: center;
    flex-direction: column;
  }
  .mark-list{
    border: 1px #eee solid;
    padding: 10px 20px;
    border-radius: 4px;
  }
  .mark-list li{
     margin-top: 12px;  
  }
  .mark-list li:nth-child(1){
    margin-top: 0px;
  }
</style>